import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

const PrivateRoute = ({ children }) => {
    const { openTimeModal } = useTimeModal();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [isAuthorized, setIsAuthorized] = useState(null);
    const token = localStorage.getItem('token');

    useEffect(() => {
        if (!token) {
            setIsAuthorized(false);
            return;
        } else {
            setIsAuthorized(true);
            return;
        }
    }, [location]);

    // Формируем правильную ссылку редиректа
    let redirectPath = location.pathname + location.search;

    if (isAuthorized === null) {
        return <Loading />;
    }

    return isAuthorized ? children : <Navigate to={`/auth/login?redirect=${redirectPath}`} />;
};

export default PrivateRoute;